import { render, staticRenderFns } from "./ColorPickerDropdown.vue?vue&type=template&id=8bc740d8&scoped=true"
import script from "./ColorPickerDropdown.vue?vue&type=script&lang=js"
export * from "./ColorPickerDropdown.vue?vue&type=script&lang=js"
import style0 from "./ColorPickerDropdown.vue?vue&type=style&index=0&id=8bc740d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc740d8",
  null
  
)

export default component.exports